<div class="container">
    <div class="col-md-4 d-flex align-items-center">
        <h2 class="reporte-no-ventas_title">
            {{ 'novedadHistoricos.tituloHistoricos' | translate }}
        </h2>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            style="min-width: 30px"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>

    <div class="col-10">
        <div class="form-group row-container">
            <app-semester-picker
                [placeholder]="'Semestre inicial'"
                [dateValue]="startDate"
                (dateSelected)="
                    onStartDateSelected($event)
                "></app-semester-picker>

            <app-semester-picker
                [placeholder]="'Semestre final'"
                [dateValue]="endDate"
                [hasError]="endDateHasError"
                (dateSelected)="
                    onEndDateSelected($event)
                "></app-semester-picker>

            <button
                class="styles_btn-accept-query query_reports_btn"
                (click)="toConsult()"
                [disabled]="!startDate || !endDate || endDateHasError"
                [ngClass]="{
                    'disabled-btn': !startDate || !endDate || endDateHasError,
                }">
                Consultar
            </button>
            <button
                class="styles_btn-accept-query query_reports_btn"
                (click)="exportData()"
                [disabled]="!dataLoaded"
                [ngClass]="{ 'disabled-btn': !dataLoaded }">
                Exportar
            </button>
        </div>
    </div>
    <ng-container *ngIf="novedadData && novedadData.length > 0">
        <table class="table mt-3">
            <thead>
                <tr>
                    <th>Año de la novedad</th>
                    <th>Semestre de la novedad</th>
                    <th>Modalidad de Carga</th>
                    <th>Fecha de Registro</th>
                    <th>Estado de la novedad</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let reportdev of novedadData">
                    <td>{{ reportdev.anio }}</td>
                    <td>{{ reportdev.semestreNombre }}</td>
                    <td>{{ 'Archivo' }}</td>
                    <!--se coloca de este modo debido a que dichos campos no existen en el back y es el unico estado que se manejara en front-->
                    <td>{{ reportdev.fechaRegistro }}</td>
                    <td>{{ 'Finalizado' }}</td>
                    <!--se coloca de este modo debido a que dichos campos no existen en el back y es el unico estado que se manejara en front-->
                </tr>
            </tbody>
        </table>
    </ng-container>
    <div *ngIf="!novedadData || novedadData.length === 0">
        <p>No hay datos disponibles para mostrar.</p>
    </div>
</div>
